export default __webpack_public_path__ + "static/media/BlackCurtain2.a2604d0d.png";